import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f65f78a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f65f78a')) {
      api.createRecord('7f65f78a', component.options)
    } else {
      api.reload('7f65f78a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f65f78a&", function () {
      api.rerender('7f65f78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-theme/index.vue"
export default component.exports